import {  Component,  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
import { Constants } from 'src/app/models/constants';
import { QRButton } from 'src/app/models/qr-button.model';
import { QRChip } from 'src/app/models/qr-chip.model';

@Component({
  selector: 'qr-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
})
export class ChipComponent {
  @Input() config!: QRChip;
  @Input() value?: string | number;
  @Output() dispatchClean: EventEmitter<string | number> = new EventEmitter<
    string | number
  >();
  buttonClear: QRButton = {
    hierarchy: QRButton.HIERARCHY_4,
    size: QRButton.SIZE_SMALL,
    icon: Constants.ICONS.CLOSE,
    iconOnly: true,
  };
  iconColor: string = '';

  ngOnChanges(): void {
    this.buttonClear.hierarchy = this.config.hierarchy;
    this.buttonClear = { ...this.buttonClear };
    this.configIconColor();
  }

  clear(): void {
    this.dispatchClean.emit(this.value);
  }

  configIconColor(): void {
    switch (this.config.hierarchy) {
      case QRButton.HIERARCHY_1:
        this.iconColor = QRIcon.COLOR_WHITE;
        break;
      case QRButton.HIERARCHY_2:
        this.iconColor = QRIcon.COLOR_PRIMARY_700;
        break;
      case QRButton.HIERARCHY_3:
        this.iconColor = QRIcon.COLOR_GREY_700;
        break;
      case QRButton.HIERARCHY_4:
        this.iconColor = QRIcon.COLOR_GREY_700;
        break;
      case QRButton.HIERARCHY_WHATSAPP_1:
        this.iconColor = QRIcon.COLOR_WHITE;
        break;
    }
  }
}
